import React from "react";
import MobileWithdrawSection from "./mobile/MobileWithdrawSection";
import WebWithdrawSection from "./web/WebWithdrawSection";
import ResponsiveComponent from "../../../../components/common/ResponsiveComponent";

const WithdrawSection: React.FC = () => {
  return (
    <ResponsiveComponent
      mobileComponent={<MobileWithdrawSection />}
      webComponent={<WebWithdrawSection />}
    />
  );
};

export default WithdrawSection;
